import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    ReserOperaStayEdit,
    ReserOperaRoomsEdit,
    ReserOperaGuestEdit,
    ReserOperaAdditionalEdit,
} from "../../Services/Service"; // apna path adjust karna

// ── Stay Edit ──
export const editOperaStay = createAsyncThunk(
    "ReserOperaEdit/editStay",
    async (postData, { rejectWithValue }) => {
        try {
            const res = await ReserOperaStayEdit(postData);
            return res;
        } catch (error) {
            return rejectWithValue(error?.message || "Stay edit failed");
        }
    }
);

// ── Room Edit ──
export const editOperaRoom = createAsyncThunk(
    "ReserOperaEdit/editRoom",
    async (postData, { rejectWithValue }) => {
        try {
            const res = await ReserOperaRoomsEdit(postData);
            return res;
        } catch (error) {
            return rejectWithValue(error?.message || "Room edit failed");
        }
    }
);

// ── Guest Edit ──
export const editOperaGuest = createAsyncThunk(
    "ReserOperaEdit/editGuest",
    async (postData, { rejectWithValue }) => {
        try {
            const res = await ReserOperaGuestEdit(postData);
            return res;
        } catch (error) {
            return rejectWithValue(error?.message || "Guest edit failed");
        }
    }
);

// ── Additional/Billing Edit ──
export const editOperaAdditional = createAsyncThunk(
    "ReserOperaEdit/editAdditional",
    async (postData, { rejectWithValue }) => {
        try {
            const res = await ReserOperaAdditionalEdit(postData);
            return res;
        } catch (error) {
            return rejectWithValue(error?.message || "Additional edit failed");
        }
    }
);

// ── Slice ──
const ReserOperaEditSlice = createSlice({
    name: "ReserOperaEdit",
    initialState: {
        stayLoading: false,
        roomLoading: false,
        guestLoading: false,
        additionalLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {

        // Stay
        builder
            .addCase(editOperaStay.pending, (state) => { state.stayLoading = true; state.error = null; })
            .addCase(editOperaStay.fulfilled, (state) => { state.stayLoading = false; })
            .addCase(editOperaStay.rejected, (state, action) => { state.stayLoading = false; state.error = action.payload; });

        // Room
        builder
            .addCase(editOperaRoom.pending, (state) => { state.roomLoading = true; state.error = null; })
            .addCase(editOperaRoom.fulfilled, (state) => { state.roomLoading = false; })
            .addCase(editOperaRoom.rejected, (state, action) => { state.roomLoading = false; state.error = action.payload; });

        // Guest
        builder
            .addCase(editOperaGuest.pending, (state) => { state.guestLoading = true; state.error = null; })
            .addCase(editOperaGuest.fulfilled, (state) => { state.guestLoading = false; })
            .addCase(editOperaGuest.rejected, (state, action) => { state.guestLoading = false; state.error = action.payload; });

        // Additional
        builder
            .addCase(editOperaAdditional.pending, (state) => { state.additionalLoading = true; state.error = null; })
            .addCase(editOperaAdditional.fulfilled, (state) => { state.additionalLoading = false; })
            .addCase(editOperaAdditional.rejected, (state, action) => { state.additionalLoading = false; state.error = action.payload; });
    },
});

export default ReserOperaEditSlice.reducer;